import { Component, OnInit, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';



import { DataService } from '../../../data.service';
import { AppData } from '../../../constants/app-data';
import { UrlConstant } from '../../../constants/url-constant';
import { NotificationService } from "../../../services/notification.service";

@Component({
  selector: 'app-test-history-detail',
  templateUrl: './test-history-detail.component.html',
  styleUrls: ['./test-history-detail.component.css']
})
export class TestHistoryDetailComponent implements OnInit {
 showStep = "2";
 formSubmitAttempt: boolean;
  _compSubMapApiRes: any;
 _compSubMapApiResMap: any;
 
 competitionTypes: any //[];
 subjectTypes: any //[];
 compitionLanguages: any; //[];
 testTypes: any; //[];
 
  constructor(public appData: AppData, private dataService: DataService, 
  				private router: Router, private routeParams: ActivatedRoute, 
  				public notificationService: NotificationService) { }
  loginUserId: any;
  ngOnInit(): void {
 	  this.compitionLanguages = [];
	  this.compitionLanguages.push({name:'EN', description:'English'});
	  this.compitionLanguages.push({name:'HN', description:'Hindi'});
	  this.testTypes = [];
	  
	  this.testTypes.push({name:'REGULAR', description:'Regular/Daily Test'});
	  this.testTypes.push({name:'SCHEDULED', description:'Scheduled Test'});
	  
	 let indivUserId = this.routeParams.snapshot.params['u']; //Admin/aa@ss.com
	 console.log("this.appData.selectedComapnyId :" + this.appData.selectedComapnyId );
	 this.loginUserId = indivUserId;
	
	  this.retrieveIndivCompSubMapping(indivUserId);
	  
	  if(this.appData.userId === 'Admin'){
			
		} else {
			
		}
		
		
  }

 
 
  form = new FormGroup({
    competitionTypeStr: new FormControl(''),
    subjectTypeStr: new FormControl(''),
    compitionLanguageStr: new FormControl(''),
    testTypeStr: new FormControl('')
    
  });

 
 retrieveCompLanguage(){
	 
 }
 

 retrieveCompType(){
	 
 }
 
  

  retrieveIndivCompSubMapping(indivLoginEmailId){
  	// let body = {"loginUserId" : this.appData.userId, "type" : "Software_Evaluation"};
  	  let body = {"loginUserId" : indivLoginEmailId};
    //Individual's Competition Subject Mapping List
    this.dataService.sendPostRequestWithBody(UrlConstant.apiTestSeriesIndivCompSubMappingList, body).subscribe((res: any)=>{
      console.log(res);
      this._compSubMapApiRes = res.data;
      this._compSubMapApiResMap = new Map(Object.entries( res.data.map));
      //this._compSubMapApiResMap = Object.entries( res.data.map);
      this.competitionTypes = res.data.indivList;
      
      
      this.competitionTypes = [];
      
      this._compSubMapApiResMap.forEach((value, key) => {
		  
		  let name = value[0].compSubMappingList[0].competitionType;
		  let desc = value[0].compSubMappingList[0].competitionTypeDesc;
		  
		  this.competitionTypes.push({'name': name, 'description':desc});
	  });
	  
      if(this.competitionTypes != undefined && this.competitionTypes.length == 1){
		  this.indivCompSubMappingDefaultData.competitionTypeStr = this.competitionTypes[0].name;
		  this.form.patchValue(this.indivCompSubMappingDefaultData);
		  this.competitionTypeChange(this.competitionTypes[0].name);
	  }
      
      this.form.patchValue(this.indivCompSubMappingDefaultData);
      
      this.testResultHistoryDetail();
    });
  }
  
   competitionTypeChange(competitionTypeSelectedValue){
	  this.subjectTypes = [];
	  var formData = this.form.value;
	   this.copyData(formData, this.indivCompSubMappingDefaultData);
	   
	  if(competitionTypeSelectedValue !== undefined){
		  this._compSubMapApiResMap.forEach((value, key) => {
		  	if(key === competitionTypeSelectedValue){
				  value.forEach(data =>{
					  let name = data.compSubMappingList[0].subjectType;
			 		  let desc = data.compSubMappingList[0].subjectTypeDesc;
			 		  this.subjectTypes.push({'name': name, 'description':desc});
				  });
				  if(this.subjectTypes.length === 1){
					  this.indivCompSubMappingDefaultData.subjectTypeStr = this.subjectTypes[0].name;
				  } else {
					   this.indivCompSubMappingDefaultData.subjectTypeStr = '';;
				  }
				  this.form.patchValue(this.indivCompSubMappingDefaultData);
			  }
		  });
	  } else {
		  this.indivCompSubMappingDefaultData.competitionTypeStr = '';
		  this.indivCompSubMappingDefaultData.subjectTypeStr = '';
		  this.form.patchValue(this.indivCompSubMappingDefaultData);
	  }
  }
  
  copyData(from, to){
	to.competitionTypeStr = from.competitionTypeStr;
  	to.subjectTypeStr = from.subjectTypeStr;
  	to.compitionLanguageStr = from.compitionLanguageStr;
  	to.testTypeStr = from.testTypeStr;
   }
   
 onSubmit() {
  	this.formSubmitAttempt = true;
  	 var body = this.form.value;
  	 body.userId = this.appData.userId;
  	this.dataService.sendPostRequestWithBody(UrlConstant.apiTestSeriesPrepareQuestionSet, body).subscribe((res: any)=>{
  		if(res.status === 'SUCCESS'){
			this.showStep = "2";
  			this.router.navigate(['/dashboard-test-series', {}]);
  		} else {
  			this.notificationService.error("There is some error. Please try after sometime.");
  			this.formSubmitAttempt = false;
		}
  	});
  	
  }

  clearCompetitionInitData(){
	  
	  
  }
  
  indivCompSubMappingDefaultData = {
  	competitionTypeStr : '',
  	subjectTypeStr : '',
  	compitionLanguageStr : 'EN',
  	testTypeStr : ''
  }
  
  
  
  
  
  
  ///////////////////////////////////////////
  testRecord:any;
	testResultHistoryDetail(){
		 var loginUserId = this.loginUserId;
		 var sortingOrderingList = [{'sortField':'createdDate', 'sortingOrder':"DESC"}];
		 var body = {'loginUserId': loginUserId, 'isTestCompleted':'Y', 'pageNumber':0, 'recordsPerPage':5, 'sortOrderList':sortingOrderingList};
		 //var body = {'loginUserId': loginUserId, 'pageNumber':0, 'recordsPerPage':5};
		 
	  	 //body.userId = this.appData.userId;
	  	this.dataService.sendPostRequestWithBody(UrlConstant.apiTestSeriesGetIndivTestRecord, body).subscribe((res: any)=>{
	  		if(res.status === 'SUCCESS'){
				  this.testRecord = res.data;
				  this.testRecord.forEach(tr => {
					  if(tr.isTestCompleted == 'Y'){
						  tr.isTestCompleted = "Completed";
					  } else {
						  tr.isTestCompleted = "Not Completed";
					  }
					  this.competitionTypes.forEach(ct => {
				  			if(ct.name == tr.competitionType){
								  tr.competitionType = ct.description;
							  }
				  		});
				  		this.subjectTypes.forEach(st => {
				  			if(st.name == tr.subjectType){
								  tr.subjectType = st.description;
							  }
				  		});
				  });
				  
	  			//this.router.navigate(['/dashboard-test-series',{'p':'x', 'u':loginUserId}]);
	  		} else {
	  			this.notificationService.error("There is some error. Please try after sometime.");
			}
	  	});
	}
	
	
	
	///////////////////
	
	showPreviousTestResult(testRecordId){
		 var body = {'userId': this.loginUserId, 'testRecordId':testRecordId};
	  	 //body.userId = this.appData.userId;
	  	this.dataService.sendPostRequestWithBody(UrlConstant.apiTestSeriesPreviousTestResult, body).subscribe((res: any)=>{
	  		if(res.status === 'SUCCESS'){
	  			//this.router.navigate(['/dashboard-test-series',{'p':'x', 'u':loginUserId}]);
	  			this.router.navigate(['/dashboard-test-series', {}]);
	  			//this.router.navigate(['/dashboard-history-detail', {'u':this.loginUserId}]);
	  		} else {
	  			this.notificationService.error("There is some error. Please try after sometime.");
			}
	  	});
	}
}

